import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import './i18n';
import { initSafeAreaCSS } from './utils/initSafeAreaCSS';

// Initialize safe area CSS based on browser detection
initSafeAreaCSS();

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement,
);

root.render(
  //   <React.StrictMode>
  <App />,
  //   </React.StrictMode>,
);
